var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('table',{attrs:{"id":"tabla-stock"}},[_vm._m(0),_c('tbody',_vm._l((_vm.ventas),function(venta){return _c('VentasListaCarritoEntregadasItem',{key:venta.venta_id,attrs:{"venta":venta}})}),1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('th',[_vm._v("Fecha")]),_c('th',[_vm._v("Monto")]),_c('th',[_vm._v("Punto de Entrega")]),_c('th',[_vm._v("Estado")])])
}]

export { render, staticRenderFns }